import React, { useEffect, useRef, useState } from "react";
import { db, storage } from "../firebase";
import {
  collection,
  addDoc,
  deleteDoc,
  doc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
} from "firebase/firestore";
import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject
} from "firebase/storage";
import { uploadImageToCloudinary, uploadVideoToCloudinary } from "../cloudinary";

const AdminGalleryManager = () => {
  const [items, setItems] = useState([]);
  const [file, setFile] = useState(null);
  const [type, setType] = useState("image");
  const [alt, setAlt] = useState("");
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef();

  // Cargar la galería actual
  const fetchGallery = async () => {
    const q = query(collection(db, "gallery"), orderBy("createdAt", "desc"));
    const snap = await getDocs(q);
    setItems(
      snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
    );
  };

  useEffect(() => {
    fetchGallery();
  }, []);

  // Subir imagen/video a Storage y Firestore
const handleUpload = async (e) => {
  e.preventDefault();
  if (!file || !type) return;
  setUploading(true);

  try {
    let url = "";
    if (type === "image") {
      url = await uploadImageToCloudinary(file);
    } else if (type === "video") {
      url = await uploadVideoToCloudinary(file);
    }

    await addDoc(collection(db, "gallery"), {
      url,
      alt,
      type,
      createdAt: serverTimestamp(),
      storagePath: null,
    });

    setFile(null);
    setAlt("");
    fileInputRef.current.value = "";
    fetchGallery();
    alert("¡Subido correctamente a Cloudinary!");
  } catch (err) {
    alert("Error al subir a Cloudinary: " + err.message);
  } finally {
    setUploading(false);
  }
};

  // Eliminar foto/video de Storage y Firestore
  const handleDelete = async (item) => {
    if (!window.confirm("¿Eliminar este elemento de la galería?")) return;
    try {
      // Eliminar de Storage si corresponde
      if (item.storagePath) {
        await deleteObject(ref(storage, item.storagePath));
      }
      // Eliminar de Firestore
      await deleteDoc(doc(db, "gallery", item.id));
      fetchGallery();
    } catch (err) {
      alert("Error al eliminar: " + err.message);
    }
  };

  return (
    <div className="p-8 max-w-3xl mx-auto">
      <h2 className="text-2xl font-bold mb-6 text-center">Gestionar Galería</h2>
      <form onSubmit={handleUpload} className="flex flex-col gap-4 mb-8 bg-white rounded-xl shadow-md p-6">
        <div className="flex flex-col gap-2">
          <label className="font-semibold">Tipo:</label>
          <select value={type} onChange={e => setType(e.target.value)} className="rounded-lg border p-2">
            <option value="image">Imagen</option>
            <option value="video">Video</option>
          </select>
        </div>
        <div className="flex flex-col gap-2">
          <label className="font-semibold">Archivo ({type === "image" ? "JPG, PNG" : "MP4"}):</label>
          <input
            type="file"
            accept={type === "image" ? "image/*" : "video/mp4,video/webm"}
            onChange={e => setFile(e.target.files[0])}
            ref={fileInputRef}
            required
            className="rounded-lg border p-2"
          />
        </div>
        <div className="flex flex-col gap-2">
          <label className="font-semibold">Descripción:</label>
          <input
            type="text"
            value={alt}
            onChange={e => setAlt(e.target.value)}
            maxLength={80}
            placeholder="Descripción breve"
            className="rounded-lg border p-2"
          />
        </div>
        <button
          type="submit"
          disabled={uploading}
className="bg-blue-600 text-white py-2 px-6 rounded-lg font-semibold hover:bg-blue-700 transition-all"
        >
          {uploading ? "Subiendo..." : "Subir a Galería"}
        </button>
      </form>
      <div>
        <h3 className="text-lg font-semibold mb-4">Elementos en Galería</h3>
        <div className="grid grid-cols-2 gap-4">
          {items.map(item => (
            <div key={item.id} className="bg-gray-100 rounded-xl p-2 flex flex-col items-center shadow">
              {item.type === "image" ? (
                <img src={item.url} alt={item.alt} className="w-full h-28 object-cover rounded-lg mb-2" />
              ) : (
                <video src={item.url} controls className="w-full h-28 object-cover rounded-lg mb-2" />
              )}
              <div className="text-xs text-center text-gray-700">{item.alt}</div>
              <button
                onClick={() => handleDelete(item)}
                className="mt-2 text-xs bg-red-500 text-white rounded-lg px-3 py-1 hover:bg-red-700"
              >
                Eliminar
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminGalleryManager;
